import { Link, useLocation } from 'react-router-dom';
import './style.scss';

function BreadCrumb({ customNames = {} }) {
  const location = useLocation();

  let currentLink = '';
  const crumbs = location.pathname
    .split('/')
    .filter(crumb => crumb !== '')
    .map(crumb => {
      currentLink += `/${crumb}`;
        return {
            path: currentLink,
            name: customNames[crumb] || crumb,
        };
    });

    return (
        <section className='bread-crumb-container'>
            {crumbs.map((crumb, i) => (
                <div key={i} className='bread-crumbs'>
                    / <Link to={crumb.path}> {crumb.name}</Link>
                </div>
            ))}
        </section>
    );
}

export default BreadCrumb;